import { ENV } from '../config/env';

export const API_BASE_URL = ENV.API_BASE_URL;

export const STORAGE_KEYS = {
  AUTH_TOKEN: 'shop_auth_token',
  USER_DATA: 'shop_user_data',
  CASHIER_AUTH_TOKEN: 'cashier_auth_token',
  CASHIER_DATA: 'cashier_user_data',
  CASHIER_DEVICE_FINGERPRINT: 'cashier_device_fingerprint',
  /** Cached `DeviceView` of the session device (from sign-in, refreshed via GET /cashier/me). */
  CASHIER_DEVICE: 'cashier_device',
  /**
   * @deprecated Legacy client-side device id from the old register flow. The server now resolves the
   * device at sign-in; this key is only removed (on login and logout), never read.
   */
  CASHIER_DEVICE_ID: 'cashier_device_id',
} as const;

/** Dispatched on shop login / logout so listeners (e.g. in-app popup gate) can refetch */
export const SHOP_AUTH_TOKEN_CHANGED_EVENT = 'shop-auth-token-changed';

/** Dispatched on cashier login / logout so listeners can refetch. */
export const CASHIER_AUTH_TOKEN_CHANGED_EVENT = 'cashier-auth-token-changed';

/** Sidebar shop credit balance should refresh (e.g. after transfer to player, payment return). */
export const SHOP_CREDIT_BALANCE_REFRESH_EVENT = 'shop-credit-balance-refresh';

export function dispatchShopCreditBalanceRefresh(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(SHOP_CREDIT_BALANCE_REFRESH_EVENT));
}
